import { cn } from '@/lib/utils';

type Props = {
  label: string;
  value: string | number | undefined;
  bgLabel?: string;
  label_w?: string;
  bgValue?: string;
  extra?: string | number;
  valueFontSize?: string;
};

export function LabelWithValue({
  label,
  value,
  bgLabel = 'bg-secondary',
  bgValue = 'bg-card',
  label_w = 'w-1/3',
  extra,
  valueFontSize = 'text-xs',
}: Props) {
  return (
    <div className="flex w-full justify-center gap-1">
      <div
        className={cn(
          bgLabel,
          'flex items-center justify-center rounded-sm border p-1',
          label_w,
        )}
      >
        <div className="w-full rounded-md text-center text-xs font-medium md:text-xs">
          {label}
        </div>
      </div>
      <div
        className={cn(
          bgValue,
          extra ? 'justify-between px-2 py-1' : 'justify-center p-1',
          'flex items-center rounded-lg border dark:border-lightSecondary' +
            ' w-full border-card-foreground',
        )}
      >
        <h3
          className={cn({
            'text-xs': valueFontSize === 'text-xs',
            'text-sm': valueFontSize === 'text-sm',
            'text-base': valueFontSize === 'text-base',
            'text-lg': valueFontSize === 'text-lg',
            'text-xl': valueFontSize === 'text-xl',
            'line-clamp-1 text-center font-medium': true,
          })}
        >
          {value}
        </h3>

        {extra && (
          <div className="flex items-center gap-1">
            <div className="rounded-md bg-secondary px-2 py-0.5 text-xs text-secondary-foreground">
              {extra}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
